import {createGlobalStyle} from "styled-components";
export const GlobalStyles = createGlobalStyle`
  body {
    background: ${({theme}) => theme.bgColor01};
    color: ${({theme}) => theme.fgColor01};
    transition: all 0.10s linear;
  }
  `;
